import { Observable } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ComponentDataDestService } from '../../component-data-dest.service';
import { ComponentDataSourceService } from '../../../component-data-source/component-data-source.service';
import { environment } from '../../../../environment/environment';

export interface SaveInstructorInvitationAssignmentsPayload {
  invitation_guid: string;
  assignments: Array<{ event_id: number; user_id: number }> | Record<string, number[]>;
}

export const save_instructor_invitation_assignments = (
  service: ComponentDataDestService,
  componentDataSourceService: ComponentDataSourceService,
  data: SaveInstructorInvitationAssignmentsPayload
): Observable<any> => {
  const guid = data.invitation_guid;
  const body = Array.isArray(data.assignments)
    ? { assignments: data.assignments }
    : { assignments: data.assignments };
  return service.http.post(
    `${environment.apiUrl}/events/instructor-invitations/${guid}/assignments`,
    body
  ).pipe(
    catchError(error => {
      console.error('[save_instructor_invitation_assignments] Error:', error);
      throw error;
    })
  );
};
